// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"bd83175f","123":"abe5d4d0","703":"62ee43c0"}[chunkId] + ".chunk.css";
};